import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Opportunity } from '@vendasta/sales-opportunities';

@Injectable({
  providedIn: 'root',
})
export class OpportunitySidePanelEventsService {
  private readonly sidePanelCloseEvents$$ = new Subject<void>();
  sidePanelCloseEvents$ = this.sidePanelCloseEvents$$.asObservable();
  private readonly opportunityCreatedEvents$$ = new BehaviorSubject<Opportunity>(null);
  opportunityCreatedEvents$ = this.opportunityCreatedEvents$$.asObservable();

  private readonly opportunityUpdatedEvents$$ = new BehaviorSubject<Opportunity>(null);
  opportunityUpdatedEvents$ = this.opportunityUpdatedEvents$$.asObservable();

  sidePanelCloseRequested(): void {
    this.sidePanelCloseEvents$$.next(null);
  }

  opportunityCreated(opportunity: Opportunity): void {
    this.opportunityCreatedEvents$$.next(opportunity);
  }

  opportunityUpdated(opportunity: Opportunity): void {
    this.opportunityUpdatedEvents$$.next(opportunity);
  }
}
